import { CxEvent } from '@spartacus/core';

/**
 * Indicates that the Market has changed.
 */
export class DpMarketSetEvent extends CxEvent {
  /**
     * Event's type
     */
  static readonly type = 'DpMarketSetEvent';
  activeMarket = '';
}
